export default "__VITE_ASSET__0c7c27c2__"